module.exports = __webpack_public_path__ + "img/triell-2.1467dfd3.png";